import { somePass } from '@ipfabric/utils/fp/predicate';
import { constFalse, constVoid } from 'fp-ts/lib/function';
import type { GraphRendererPlugin } from './GraphRendererPlugin';

const hasShiftModifier = (event: WheelEvent) => event.shiftKey;
const hasAltModifier = (event: WheelEvent) => event.altKey;

const hasWheelMoveModifier = somePass([hasShiftModifier, hasAltModifier]);

export const wheelMove: GraphRendererPlugin = (pluginInterface) => {
  const { viewport } = pluginInterface;

  const scrollOmnidirectionally = (event: WheelEvent) => {
    viewport.y -= event.deltaY;
    viewport.x -= event.deltaX;
  };

  const scrollHorizontally = (event: WheelEvent) => {
    viewport.x += event.deltaY;
    viewport.x -= event.deltaX;
  };

  const plugin = {
    down: constFalse,
    up: constFalse,
    move: constFalse,

    resize: constVoid,
    resume: constVoid,
    update: constVoid,

    pause: () => {
      viewport.plugins.resume('wheel');
    },
    reset: () => {
      viewport.plugins.resume('wheel');
    },
    wheel: (event: WheelEvent) => {
      if (!hasWheelMoveModifier(event)) {
        viewport.plugins.resume('wheel');

        return false;
      }

      viewport.plugins.pause('wheel');

      if (hasAltModifier(event)) {
        scrollOmnidirectionally(event);
      } else {
        scrollHorizontally(event);
      }

      viewport.emit('moved', { viewport, type: 'wheel' });

      return true;
    },
  };

  pluginInterface.viewport.plugins.add('wheel-move', plugin, 0);
};
